module.exports = __webpack_public_path__ + "img/chevrons-left.85273d59.svg";